import { render, staticRenderFns } from "./newborn.vue?vue&type=template&id=9c799634&scoped=true&"
import script from "./newborn.vue?vue&type=script&lang=js&"
export * from "./newborn.vue?vue&type=script&lang=js&"
import style0 from "./newborn.vue?vue&type=style&index=0&id=9c799634&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c799634",
  null
  
)

export default component.exports